import React from 'react'
import { Media } from 'react-breakpoints'
import ContentLoader from 'react-content-loader'

import { useStyles } from './PlaceholderLoader.style'

const PlaceholderLoader = () => {
  const classes = useStyles()

  const bgColor = '#ffffff'
  const fgColor = '#eeeeee'

  return (
    <Media>
      {({ breakpoints, currentBreakpoint }) =>
        breakpoints[currentBreakpoint] < breakpoints.md ? (
          <ContentLoader
            title='Cargando...'
            className={classes.containerHorizontal}
            backgroundColor={bgColor}
            foregroundColor={fgColor}>
            <rect x='10vw' y='100' rx='10' ry='10' width='80vw' height={18} />
            <rect x='20vw' y='130' rx='10' ry='10' width='60vw' height={18} />

            <rect x='3vw' y='200' rx='5' ry='5' width='90vw' height={40} />
            <rect x='3vw' y='260' rx='5' ry='5' width='90vw' height={40} />
            <rect x='3vw' y='340' rx='5' ry='5' width='90vw' height={40} />

            <rect x='3vw' y='420' rx='5' ry='5' width='50vw' height={15} />

            <rect x='3vw' y='460' rx='5' ry='5' width='90vw' height={40} />
            <rect x='3vw' y='530' rx='5' ry='5' width='90vw' height={40} />
            <rect x='3vw' y='600' rx='5' ry='5' width='90vw' height={40} />

            <rect x='3vw' y='665' rx='5' ry='5' width='85vw' height={15} />
            <rect x='3vw' y='710' rx='5' ry='5' width='20vw' height={40} />

            <rect x='3vw' y='780' rx='5' ry='5' width='80vw' height={15} />
            <rect x='3vw' y='825' rx='5' ry='5' width='20vw' height={40} />

            <rect x='3vw' y='895' rx='5' ry='5' width='70vw' height={15} />
            <rect x='3vw' y='940' rx='25' ry='25' width='20vw' height={25} />

            <rect x='3vw' y='1010' rx='5' ry='5' width='70vw' height={15} />
            <rect x='3vw' y='1055' rx='25' ry='25' width='20vw' height={25} />

            <rect x='3vw' y='1125' rx='5' ry='5' width='90vw' height={40} />

            <rect x='20vw' y='1240' rx='5' ry='5' width='55vw' height={48} />
          </ContentLoader>
        ) : (
          <ContentLoader
            title='Cargando...'
            className={classes.containerHorizontal}
            backgroundColor={bgColor}
            foregroundColor={fgColor}>
            <rect x='35vw' y='77' rx='10' ry='10' width='30vw' height={18} />

            {/* left column */}
            <rect x='17vw' y='160' rx='5' ry='5' width='27vw' height={40} />
            <rect x='17vw' y='240' rx='5' ry='5' width='27vw' height={40} />
            <rect x='17vw' y='320' rx='5' ry='5' width='27vw' height={40} />

            <rect x='17vw' y='410' rx='5' ry='5' width='11vw' height={15} />

            <rect x='17vw' y='450' rx='5' ry='5' width='10vw' height={40} />
            <rect x='17vw' y='520' rx='5' ry='5' width='10vw' height={40} />

            {/* right column */}
            <rect x='56vw' y='160' rx='5' ry='5' width='27vw' height={40} />

            <rect x='56vw' y='260' rx='5' ry='5' width='20vw' height={15} />
            <rect x='78vw' y='240' rx='5' ry='5' width='5vw' height={40} />

            <rect x='56vw' y='330' rx='5' ry='5' width='18vw' height={15} />
            <rect x='78vw' y='310' rx='5' ry='5' width='5vw' height={40} />

            <rect x='56vw' y='400' rx='5' ry='5' width='12vw' height={15} />
            <rect x='78vw' y='380' radius={10} width='5vw' height={40} />

            <rect x='56vw' y='470' rx='5' ry='5' width='12vw' height={15} />
            <rect x='78vw' y='450' radius={10} width='5vw' height={40} />

            <rect x='56vw' y='510' rx='5' ry='5' width='27vw' height={40} />

            <rect x='41vw' y='670' rx='5' ry='5' width='13vw' height={50} />
          </ContentLoader>
        )
      }
    </Media>
  )
}

export default PlaceholderLoader
